import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { DEALS_ROUTE } from "./deal.constant";

const DealsList = Loadable(
  lazy(() =>
    import("./DealsList").then(({ DealsList }) => ({
      default: DealsList,
    }))
  )
);

const ManageDeals = Loadable(
  lazy(() =>
    import("./ManageDeals").then(({ ManageDeals }) => ({
      default: ManageDeals,
    }))
  )
);

export const dealRoutes = [
  {
    path: DEALS_ROUTE,
    element: (
      <AuthorizedRoute
        moduleIds={[ALLOWED_MODULES.LEADS]}
        allowFullAccess
      >
        <DealsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${DEALS_ROUTE}/manage/:uuid`,
    element: (
      <AuthorizedRoute
        moduleIds={[ALLOWED_MODULES.LEADS]}
        allowFullAccess
      >
        <ManageDeals />
      </AuthorizedRoute>
    ),
  },
];
